import { render, staticRenderFns } from "./bulma_help.vue?vue&type=template&id=41dfa514&scoped=true&lang=html"
import script from "./bulma_help.vue?vue&type=script&lang=js"
export * from "./bulma_help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dfa514",
  null
  
)

export default component.exports